<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			
			<!-- <el-tab-pane v-for="(item,key) in this.$store." :key="key" label="串口配置" name="first" ><ComCh></ComCh></el-tab-pane> -->
		    <el-tab-pane label="串口配置" name="first" ><ComCh></ComCh></el-tab-pane>
		    <el-tab-pane label="从机配置" name="second"><Lufft></Lufft></el-tab-pane>
		    <el-tab-pane label="串口配置从机" name="three"><ComLufft/></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import ComCh from '../../components/com/ComCh.vue'
	import Lufft from '../../components/com/Lufft.vue'
	import ComLufft from '../../components/com/ComLufft.vue'
	export default {
		name: "ComMa",
	    data() {
	      return {
	        activeName: 'first'
	      };
	    },
		components:{
			ComCh,
			Lufft,
			ComLufft
		},
	    methods: {
	      handleClick(tab, event) {
	        console.log(tab, event);
	      }
	    }
	  };
</script>
	
<style>
</style>
